import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Group } from "./group";
import { User } from "../../users/_types/user";

export class GroupUser extends Resource {
    public override type = 'groupUsers';

    @prop()
    @required()
    public groupId!: string;
    public group!: Group;

    @prop()
    public userId!: string;
    public user!: User;

}

